import React, { createContext, useState } from 'react';

export const NavigationContext = createContext();

const NavigationProvider = ({ children }) => {
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [tabNavigation, setTabNavigation] = useState([]);
  const [showLogo, setShowLogo] = useState(false);
  const [toolbarSection, setToolbarSection] = useState(null);
  const [headHeight, setHeadHeight] = useState(0);
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <NavigationContext.Provider
      value={{
        breadcrumb,
        headHeight,
        setBreadcrumb,
        setHeadHeight,
        setShowLogo,
        setShowSidebar,
        setSubtitle,
        setTabNavigation,
        setTitle,
        setToolbarSection,
        showLogo,
        showSidebar,
        subtitle,
        tabNavigation,
        title,
        toolbarSection,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
